import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import BackIcon from '@ad-scripts/presentation/components/lib/icons/chevron_left';
import { Button, ButtonTypes } from 'src/presentation/components/agent_desktop_components';
import useRouter from 'src/presentation/hooks/useRouter';
import { selectAnon } from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';

const BackToThreadsListButton = () => {
  const { history } = useRouter();
  const anon = useSelector(selectAnon);

  const handleBackButton = () => {
    const pathParts = history.location.pathname.split('/');
    pathParts.pop();

    history.push({ pathname: pathParts.join('/'), search: history.location.search });
  };

  if (anon) {
    return null;
  }

  return (
    <StyledBackButton type={ButtonTypes.SECONDARY} onClick={handleBackButton}>
      <StyledBackIcon />
      Threads
    </StyledBackButton>
  );
};

const StyledBackButton = styled(Button)`
  display: flex;
  align-items: center;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
  position: fixed;

  top: 16px;
  left: 24px;
  z-index: 5;
`;

const StyledBackIcon = styled(BackIcon)`
  height: 16px;
  margin-right: 3px;
  stroke-width: 0.85;
  stroke: ${p => p.theme.colors.gray600};
  width: 16px;
`;

export default BackToThreadsListButton;
